module.exports = __webpack_public_path__ + "static/media/health_data_network.f1a30820.jpg";